import { FilterFilled } from "@ant-design/icons";
import { data } from "../../../constants";
import { NameWrapper, StarIcon } from "./elements";
import { star } from "../../../assets/icons/index";

export const reasonForFailureCol = {
  title: "Reason For Failure",
  dataIndex: "reason",
  key: "reason",
  width: "280px",
};

export const reasonCol = {
  title: "Reason",
  dataIndex: "reason",
  key: "reason",
  width: "280px",
};

export const dateAppliedCol = {
  title: "Date Applied",
  dataIndex: "dateApplied",
  key: "dateApplied",
  width: "200px",
};

export const ColumnsComponent = (
  filterDropdown: any,
  setFilterDropdownVisible: any
) => {
  return [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "280px",
      fixed: "left",
      render: (text: string, row: any): any => {
        return row.referredBy ? (
          <NameWrapper>
            <span>{text}</span>
            <StarIcon src={star} />
          </NameWrapper>
        ) : text;
      },
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
      width: "220px",
      filterIcon: (
        <FilterFilled
          className={
            filterDropdown.dropdownKey === "position" &&
            filterDropdown.isVisible
              ? "tableFilterDropdownPositionActive"
              : ""
          }
        />
      ),
      filterDropdownVisible:
        filterDropdown.isVisible && filterDropdown.dropdownKey === "position",
      onFilterDropdownVisibleChange: (visible: any) => {
        setFilterDropdownVisible({
          isVisible: visible,
          dropdownKey: "position",
        });
      },
      filters: data.positionApplied.map((position: string) => {
        return { text: position, value: position };
      }),
      onFilter: (value: any, record: any) =>
        record.position.indexOf(value) === 0,
    },
    {
      title: "Date Moved",
      dataIndex: "dateMoved",
      key: "dateMoved",
      width: "200px",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: [
        { text: data.applicationStatus[2], value: data.applicationStatus[2] },
        { text: data.applicationStatus[3], value: data.applicationStatus[3] },
        { text: data.applicationStatus[4], value: data.applicationStatus[4] },
      ],
      width: "180px",
      filterIcon: (
        <FilterFilled
          className={
            filterDropdown.dropdownKey === "status" && filterDropdown.isVisible
              ? "tableFilterDropdownStatusActive"
              : ""
          }
        />
      ),
      filterDropdownVisible:
        filterDropdown.isVisible && filterDropdown.dropdownKey === "status",
      onFilterDropdownVisibleChange: (visible: any) => {
        setFilterDropdownVisible({ isVisible: visible, dropdownKey: "status" });
      },
      onFilter: (value: any, record: any) => record.status.indexOf(value) === 0,
      render: (text: string) => (text === "Unassigned" ? "" : text),
    },
  ];
};

export default ColumnsComponent;
